import React, {Component} from 'react';
import './CalloutCardComponent.less';
import ErrorViewComponent from '../ErrorViewComponent/ErrorViewComponent';

class CalloutCardComponent extends Component {
    render() {
        return (
            <div className="CalloutCardComponent box-shadow--nav">
                <ErrorViewComponent error={this.props.error} errorTitle={this.props.errorTitle}/>
                {this.props.content}
            </div>
        );
    }
}

export default CalloutCardComponent;

